import Plan3D from './plan-3d.js'
import Plan2D from './plan-2d.js'

export class PlanService{
	constructor(spot){
		this.initialized = false;
		this.plan2D;
		this.plan3D;
		this.floors;

		this.interactions = {
			focus: null,
			open: null,
			hover: null,
		};

		// Products
		this.products = spot.products.map(spotProduct => {
			// Create
			return new PlanProduct(spotProduct);
			
			// planProduct = new PlanProduct(spotProduct);
			// Reference PlanProduct <> SpotProduct
			// spotProduct.nodes.planProduct = planProduct;
			// return spotProduct.nodes.planProduct;
		});

		// Navigation
		this.nav = new PlanNavigation(spot);

		// Focus when minicard slider changes
		document.addEventListener('cmzSpotPlanProductFocus', e => {
			this.focusProduct(this.getProduct(e.detail.productId), false);
		});
		
		document.addEventListener('cmzSpotPlanProductUnfocus', () => {
			this.unfocusProduct();
		});

		// 2D
		if (CMZ.selector.plan2D){
			this.plan2D = new Plan2D(this);
			
			// Attach plan product to spot product
			document.addEventListener('cmzSpotPlan2DLoaded', (e) => {
				this.products.forEach(planProduct => {
					const product2D = e.detail.plan.getProduct(planProduct.id);

					if (!product2D) return;

					// Bind PlanProduct <> Plan2D_Product
					planProduct.product2D = product2D;
					product2D.planProduct = planProduct;
					
					// Update initial states view
					planProduct.updateState();
					
				});
			});

			if (spot.inputs.viewPlan2D?.checked && !spot.chosen){
				this.plan2D.initialize();
			}
		}

		// 3D
		if (CMZ.selector.plan3D){
			this.plan3D = new Plan3D(spot.node, spot.display.settings, this);


			document.addEventListener('cmzSpotPlan3DHoverChanged', (e) => {
				// const product3D = e.detail.productId;
				const planProduct = e.detail.productId ? this.getProduct(e.detail.productId) : false;
				this.setInteraction('hover', planProduct);
			});
			
			// Attach plan product to spot product and set initial states
			document.addEventListener('cmzSpotPlan3DLoaded', (e) => {
				this.products.forEach(planProduct => {
					const product3D = e.detail.plan.getProduct(planProduct.id);

					if (!product3D) return;

					// Bind PlanProduct <> Plan2D_Product
					planProduct.product3D = product3D;
					product3D.planProduct = planProduct;
					
					// Attach product3D to planProduct
					// planProduct.product3D = product3D;

					// Attach planProduct to productPlan3D (dirty)
					// product3D.planProduct = this.getProduct(planProduct.id);

					// Set initial states
					planProduct.updateState();
				});
				
				this.plan3D.update.highlight = true;
				this.plan3D.render();

				// Run callback (used to fire render())
				// if (e?.detail?.callback){
				// 	e.detail.callback();
				// }
			});

			if (spot.inputs.viewPlan3D?.checked && !spot.chosen){
				this.plan3D.initialize();
			}
		}

		// Open product popup on click
		document.addEventListener('cmzPlanProductClicked', (e) => {
			const id = e?.detail?.productId;

			if (!id) return;
			
			const product = this.getProduct(id);

			if (!product) return;

			if (window.innerWidth >= 1024){
				product.states.open ? this.closeProduct() : this.openProduct(product);
			}
			else{
				// Focus product
				this.focusProduct(product);
				
				// Open nav
				// this.nav.setAttribute('data-status', 'open');
			}

			
			// Toggle details
			// if (product.planPopup){
				// product.planPopup.checked ? document.querySelector('#cmz-spot-plan-product-none').click() : product.planPopup.click();
			// }

			if (this.plan3D){
				// this.plan3D.onProductClicked(id);
			}
			
			if (this.plan2D){
				// this.plan2D.onProductClicked(id);
			}
		});

		// Remove highlight when spot product unselect
		document.querySelector('#cmz-spot-plan-product-none').addEventListener('change', () => {
			this.setInteraction('open', null);
		})

		// Floors
		if (this.plan2D && CMZ.floors.length > 1){ // Currently only for 2D
			this.floors = new PlanFloorService(spot, this);
		}
	}

	triggerChildCallback(callbackName, param = null){
		if (typeof this[callbackName] == 'function'){
			this[callbackName](param);
		}
	}

	setInteraction(name, product){
		// Bail early if no change
		if (product == this.interactions[name]){
			return;
		}

		// Reset previous
		if (this.interactions[name]){
			this.interactions[name].setState(name, false);
		}

		// Set state
		if (product){
			product.setState(name, true);
		}

		// Update global
		this.interactions[name] = product;

		if (this.plan2D){
			// ...
		}

		if (this.plan3D){
			this.plan3D.update.highlight = true;
			this.plan3D.render();
		}
	}

	getProduct(id){
		return this.products.find(product => product.id == id);
	}

	_openOrFocusProduct(openOrFocus, planProduct){
		// Highlight on
		this.setInteraction(openOrFocus, planProduct);

		// Scroll minicard slider
		this.nav.scrollMinicardSliderTo(planProduct.spotProduct?.nodes?.minicard);
		// document.dispatchEvent(new CustomEvent('cmzPlanProductFocused', {detail: {product}}));

		// Move cameras
		if (this.plan2D){
			this.plan2D.panToProduct(planProduct?.product2D);

			if (this.floors){
				this.floors.moveToProduct(planProduct);
			}
		}

		if (this.plan3D && planProduct?.product3D){
			// this.plan3D.afterProductFocused(product);
			this.plan3D.moveCameraTo(planProduct.product3D);
			
			// Render
			this.plan3D.render();
		}
		
	}

	openProduct(planProduct){
		this._openOrFocusProduct('open', planProduct);
		
		// Open details
		planProduct?.details?.click();
	}
	
	focusProduct(planProduct){
		this._openOrFocusProduct('focus', planProduct);
	}

	closeProduct(){
		// Highlight off
		this.setInteraction('open', null);
		
		// Close popup
		document.querySelector('#cmz-spot-plan-product-none').click();

		// Child callback
		// this.triggerChildCallback('afterProductClosed');
	}
	
	unfocusProduct(){
		// Highlight off
		this.setInteraction('focus', null);
		
		// Child callback
		// this.triggerChildCallback('afterProductUnfocused');
	}
	/*
	onProductClicked(productId){ // trigger by Spot() via cmzPlanProductClicked in customizer.js
		const product = this.getProduct(productId);

		if (product){
			if (window.innerWidth >= 1024){
				product.states.open ? this.closeProduct() : this.openProduct(product);
			}
			else{
				this.focusProduct(product);
			}
		}
	}
		*/
}

class PlanProduct{
	constructor(spotProduct){
		this.id = spotProduct.id;
		this.details = document.querySelector('#cmz-spot-plan-product-input-' + this.id);
		this.status = spotProduct.status;
		this.status_label = spotProduct.status_label;
		
		this.states = {
			hover: false,
			open: this.details ? this.details.checked : false,
			available: spotProduct.available,
			booked: spotProduct.booked,
			filtered: spotProduct.filtered,
			focus: false,
		};
		
		this.floor; // Set by FloorService
		this.product2D; // Set by Plan2D when loaded
		this.product3D; // Set by Plan3D when loaded

		// Attach to spotProduct
		this.spotProduct = spotProduct;
		spotProduct.nodes.planProduct = this;
	}

	openDetails(){ // now managed by Spot()
		if (this.details && !this.details.checked){
			this.details.click();
		}
	}
/*
	setStatus(status, status_label){
		this.status = status;
		this.status_label = status_label;
	
		if (typeof this.onStatusChange == 'function'){
			this.onStatusChange();
		}

		// Scope up to Spot and trigger status change
		// document.dispatchEvent(new CustomEvent('cmzSpotPlanProductStatusChanged', {detail: {
		// 	productId: this.id,
		// 	status: this.status,
		// }}));
	}
*/
	setState(name, value){
		this.states[name] = value;

		this.updateState();
	}

	updateState(){
		if (this.product2D){
			this.product2D.updateState(this.states);
		}

		if (this.product3D){
			this.product3D.updateState(this.status, this.states);
		}
		
		if (this.floor){
			this.floor.updateState();
		}
	}
/*
	setInitialStates(spotProduct){ // fire by class Product from customizer.js when plan loaded
		// Status
		this.setStatus(spotProduct.status, spotProduct.status_label);
		
		// States
		this.setState('available', spotProduct.available);
		this.setState('booked', spotProduct.booked);
		this.setState('filtered', spotProduct.filtered);
	}*/
}

class PlanFloorService{
	constructor(spot, planService){ // only pass PlanService (?)
		this.items = [];
		this.min = true;
		this.max = false;
		this.multifloor = false;
		this.current;

		// Create report and add al DB items
		const report = CMZ.floors.map(floor => {
			return {
				id: floor.id,
				name: floor.name,
				db: true,
				plan2D: false,
			};
		});

		// Create floors
		spot.products.forEach(product => {
			let floorId = product.floor;
			// let floorId = product.floor.toLowerCase();
			let floor = this.getFloor(floorId);

			if (!floor){
				floor = new PlanFloor(floorId, this.items.length);
				
				// Add floor 2D svg
				if (planService.plan2D){
					floor.plan2D = planService.plan2D.getFloorNode(floor.id);

					// Add to report
					const reportIndex = report.findIndex(_floor => _floor.id == floor.id);

					if (reportIndex !== -1){
						report[reportIndex].plan2D = true;
					}
				}

				this.items.push(floor);
			}

			// Add product to floor
			floor.addProduct(product.nodes.planProduct);
			
			// Attach floor to product
			product.nodes.planProduct.floor = floor;
		});

		console.log('Floor:', report);
		
		if (!this.items) return;
		
		this.multifloor = this.items.length > 1;
		
		// Set initial state
		this.items.forEach(item => item.updateState());

		// Buttons
		this.nav = {
			up: spot.node.querySelectorAll('.cmz-spot-plan-toolbar-floorup'),
			down: spot.node.querySelectorAll('.cmz-spot-plan-toolbar-floordown'),
		};

		if (this.nav.up.length){
			this.nav.up.forEach(item => {
				item.addEventListener('click', this.up.bind(this));
			});
		}

		if (this.nav.down.length){
			this.nav.down.forEach(item => {
				item.addEventListener('click', this.down.bind(this));
			});
		}

		// Wheel
		this.wheel = {
			slider: document.querySelector('.cmz-spot-plan-toolbar-floors-list-inner'),
			debounce: null,
			// items: [...document.querySelectorAll('.cmz-spot-plan-toolbar-floors-list-item')]
		};

		this._detectCurrentFloorOnWheelScroll = () => this.detectCurrentFloorOnWheelScroll();
		this._enableWheelEventDebounced = () => this.enableWheelEventDebounced();

		this.wheel.slider.addEventListener('scroll', this._detectCurrentFloorOnWheelScroll);

		this.items.forEach(item => {
			if (!item.wheelItem) return;

			if (item.wheelItem){
				item.wheelItem.addEventListener('click', () => {
					this.goTo(item.index);
				});
			}

			if (item.sliderItem){
				item.sliderItem.addEventListener('click', () => {
					this.goTo(item.index);
				});
			}
		})

		// Slider
		this.slider = {
			node: spot.node.querySelector('.cmz-spot-plan-toolbar-floors-slider-list'),
			thumb: spot.node.querySelector('.cmz-spot-plan-toolbar-floors-slider-thumb'),
			indicatorTimeout: null,
			start: {x: 0, y: 0},
			diff: {x: 0, y: 0},
			shift: 0,
			current: 0,
			maxShift: 0,
		};
		
		this._onSliderStarts = e => this.onSliderStarts(e);
		this._onSliderMoves = e => this.onSliderMoves(e);
		this._onSliderEnds = e => this.onSliderEnds(e);
		
		this.slider.thumb.addEventListener('mousedown', this._onSliderStarts);
		
		// Go to initial floor (for now, only binded to 2D plan)
		if (planService.plan2D?.initialized){
			this.initialize();
		}
		else{
			// Delay until plan 2D initialized to make sure node bounding box are correctly computde
			document.addEventListener('cmzSpotPlan2DLoaded', () => {
				this.initialize();
			});
		}
	}

	initialize(){
		const initialId = CMZ.selector.settings?.initial_floor || '0';
		const initialFloor = this.getFloor(initialId) || this.items[0];
		
		// Got to initial floor if avaiable
		if (initialFloor.states.available){
			this.goTo(initialFloor.index);
			return;
		}
		
		// Go to closest available from ground floor
		if (this.goToClosestAvailable(0) !== null){
			return;
		}

		// Fallback on first floor otherwise
		this.goTo(0);
	}

	getFloor(id){
		return this.items.find(floor => floor.id == id);
	}

	getCurrent(){
		return this.current || null;
		// return this.current ? this.items[this.current.index] : null;
	}

	up(){
		this.goTo(Math.min(this.current.index + 1, this.items.length - 1));
	}
	
	down(){
		this.goTo(Math.max(this.current.index - 1, 0));
	}

	goTo(index, origin = ''){
		// Bail early if floor does not change
		if (this.current && this.current.index == index){
			return;
		}

		// console.log('Set current:', index);

		this.current = this.items[index];

		// Update min/max
		this.max = index >= this.items.length - 1;
		this.min = index <= 0;

		// Update view
		this.updateView(origin);
	}

	goToClosestAvailable(fromIndex = null){
		const current = fromIndex !== null ? fromIndex : this.current.index;

		console.log(current);

		const closest = {
			distance: Infinity,
			index: null
		};

		// Get the closest from current
		this.items.forEach(floor => {
			if (!floor.states.available) return;
			
			const distance = Math.abs(current - floor.index);
			console.log(floor.index, floor.states.available, distance);

			if (distance < closest.distance){
				closest.index = floor.index;
				closest.distance = distance;
			}
		});

		if (closest.index !== null){
			this.goTo(closest.index);
		}

		return closest.index;
	}

	updateView(origin = ''){
		// Floors
		this.items.forEach(item => {
			item.unsetCurrent();
			// item.classList.remove('active');
		})
		
		this.current.setCurrent();
		// item.classList.add('active');

		// Update nav
		this.nav.up.forEach(item => {
			this.max ? item.setAttribute('disabled', 'true') : item.removeAttribute('disabled');
		});

		this.nav.down.forEach(item => {
			this.min ? item.setAttribute('disabled', 'true') : item.removeAttribute('disabled');
		});

		// Update wheel
		if (origin != 'wheel'){
			const node = this.getCurrent().wheelItem;

			if (node){
				// Disable temporarely wheel power to change floor when scrolled
				this.disableWheelEventDebounced();
				
				const centerItem = node.offsetTop + (node.offsetHeight / 2);
				const centerSlider = this.wheel.slider.offsetHeight / 2;

				this.wheel.slider.scrollTo({top: centerItem - centerSlider, left: 0, behavior: 'smooth'});
			}
		}
		
		// Update slider floor indicator
		this.slider.thumb.style.setProperty('--current', this.current.index);
		this.slider.thumb.style.setProperty('--width', this.current?.sliderIndicator?.offsetWidth + 'px');
		
		if (origin != 'slider'){
			// Center thumb to new current floor
			this.moveSliderThumbToCurrentFloor();

			// Temporarely show floor indicactor
			clearTimeout(this.slider.indicatorTimeout);
			this.slider.thumb.classList.add('show-floorname');

			this.slider.indicatorTimeout = setTimeout(() => {
				this.slider.thumb.classList.remove('show-floorname');
			}, 2000)

			// Set indexes for CSS transitions
			this.setItemsIndexes();
		}
	}

	moveToProduct(planProduct){
		if (planProduct.floor){
			this.goTo(planProduct.floor.index);
		}
	}

	// Wheel
	detectCurrentFloorOnWheelScroll(){
		const center = this.wheel.slider.offsetHeight / 2;

		// Detect active
		for (let i = 0; i < this.items.length; i++) {
			const node = this.items[i].wheelItem;

			if (!node) continue;
			
			const top = node.offsetTop - this.wheel.slider.scrollTop;
			const bottom = top + node.offsetHeight;
			
			if (top <= center && bottom > center){
				if (this.current != this.items[i].index){
					this.goTo(this.items[i].index, 'wheel');
				}

				break;
			}
		}
	}

	enableWheelEventDebounced(){
		clearTimeout(this.wheel.debounce);

		this.wheel.debounce = setTimeout(() => {
			// Enable back change floor when wheel moves
			this.wheel.slider.addEventListener('scroll', this._detectCurrentFloorOnWheelScroll);

			// Disable debounce
			this.wheel.slider.removeEventListener('scroll', this._enableWheelEventDebounced);
		}, 50);
	}

	disableWheelEventDebounced(){
		// Disable change floor when wheel moves
		this.wheel.slider.removeEventListener('scroll', this._detectCurrentFloorOnWheelScroll);
		
		// Enable debounce
		this.wheel.slider.addEventListener('scroll', this._enableWheelEventDebounced);
	}

	// Slider
	onSliderStarts(e){
		document.body.setAttribute('data-cursor', 'grabbing');
		this.slider.thumb.classList.add('is-grabbing');

		this.slider.maxShift = this.slider.node.offsetHeight;
		this.slider.start.x = e.clientX;
		this.slider.start.y = e.clientY;
		this.slider.diff.y = 0;
		this.slider.diff.x = 0;

		window.addEventListener('mousemove', this._onSliderMoves);
		window.addEventListener('mouseup', this._onSliderEnds);
	}

	onSliderMoves(e){
		// Bail early if touch didn't start on the element
		// if (this.slider.start.y === null) return;

		// Get diff
		this.slider.diff.x = this.slider.start.x - e.clientX;
		this.slider.diff.y = this.slider.start.y - e.clientY;

		// Bail early if horizontal scroll intended
		// if (Math.abs(this.slider.diff.x) > Math.abs(this.slider.diff.y)) return;
		
		// Get clamped diff
		this.slider.shift = Math.max(0, Math.min(this.slider.maxShift, this.slider.current + this.slider.diff.y));

		// Move thumb
		this.slider.thumb.style.setProperty('--y', (this.slider.shift * -1) + 'px');

		// Change active floor
		for (let i = 0; i < this.items.length; i++) {
			const item = this.items[i];
			
			if (!item.sliderItem) continue;

			const thumbPosition = this.slider.node.offsetHeight - this.slider.shift;
			// const top = item.sliderItem.offsetTop - item.sliderItem.parentNode.offsetTop;
			const top = item.sliderItem.offsetTop;
			const bottom = top + item.sliderItem.offsetHeight;

			if (top <= thumbPosition && bottom > thumbPosition){
				this.goTo(item.index, 'slider');
				break;
			}
			
		}
	}
	
	onSliderEnds(e){
		// Reset state
		document.body.removeAttribute('data-cursor');
		this.slider.thumb.classList.remove('is-grabbing');

		// Stop listeners
		window.removeEventListener('mousemove', this._onSliderMoves);
		window.removeEventListener('mouseup', this._onSliderEnds);
		
		// Reset touch start
		// this.slider.start.y = null;
		
		// Save current position
		this.slider.current = this.slider.shift;
		
		// Center thumb to new current floor
		this.moveSliderThumbToCurrentFloor();

		// Set indexes for CSS transitions
		this.setItemsIndexes();
	}

	setItemsIndexes(){
		const current = this.getCurrent();

		if (!current) return;

		this.items.forEach(item => {
			if (!item.sliderItem) return;

			const diff = Math.abs(item.index - current.index);
			
			item.sliderItem.style.setProperty('--index', diff);
		});
	}

	moveSliderThumbToCurrentFloor(){
		if (!this.current?.sliderItem) return;

		const currentItem = this.current?.sliderItem;

		// const top = currentItem.offsetTop + currentItem.offsetHeight - currentItem.parentNode.offsetTop;
		// const center = top - (currentItem.offsetHeight / 2);

		const top = currentItem.offsetTop;
		const center = (currentItem.offsetTop + (currentItem.offsetHeight / 2));
		const adjustment = 4; // Arbitrary offset adjustement (due to item borders?)

		this.slider.shift = this.slider.node.offsetHeight - center;

		this.slider.current = this.slider.shift;

		// currentItem.parentNode.style.setProperty('--top', top + 'px');
		// currentItem.parentNode.style.setProperty('--center', center + 'px');

		// this.slider.node.offsetHeight
		this.slider.thumb.style.setProperty('--y', (this.slider.shift * -1) + adjustment + 'px');
		// ... 
	}
}

class PlanFloor{
	constructor(id, index){
		// this.node = node;
		// this.id = id.toLowerCase();
		this.id = id;
		this.index = index;
		// this.id = this.node.id.replace('floor-', '').toLowerCase();
		// this.name = this.id;
		this.products = [];
		this.wheelItem = document.querySelector('.cmz-spot-plan-toolbar-floors-list-item[data-id="' + this.id + '"]');
		this.sliderItem = document.querySelector('.cmz-spot-plan-toolbar-floors-slider-list-item[data-id="' + this.id + '"]');
		this.sliderIndicator = document.querySelector('.cmz-spot-plan-toolbar-floors-slider-floornames-inner > li[data-id="' + this.id + '"]');
		this.plan2D;
		// this.plan3D;

		this.states = {
			hover: false,
			open: false,
			// filtered: true,
			available: false,
			// booked: true,
			focus: false,
		};
	}

	addProduct(product){
		this.products.push(product);
	}

	setCurrent(){
		// Update wheel item
		if (this.wheelItem){
			this.wheelItem.classList.add('is-current');
		}
		
		// Update slider item
		if (this.sliderItem){
			this.sliderItem.classList.add('is-current');
		}

		// Show floor SVG
		if (this.plan2D){
			this.plan2D.classList.add('is-current');

			// Hide products tips
			this.products.forEach(product => {
				if (product.product2D?.tip){
					product.product2D.tip.classList.add('is-floor-active');
					// product.product2D.showTip();
				}
			});
		}
	}
	
	unsetCurrent(){
		// Update wheel item
		if (this.wheelItem){
			this.wheelItem.classList.remove('is-current');
		}

		// Update slider item
		if (this.sliderItem){
			this.sliderItem.classList.remove('is-current');
		}

		// Hide floor SVG
		if (this.plan2D){
			this.plan2D.classList.remove('is-current');
			
			// Hide products tips
			this.products.forEach(product => {
				if (product.product2D?.tip){
					product.product2D.tip.classList.remove('is-floor-active');
					// product.product2D.hideTip();
				}
			});
		}

	}

	updateState(){
		// Reset state
		this.states = {
			hover: false,
			open: false,
			// filtered: true,
			available: false,
			// booked: true,
			focus: false,

		};

		this.products.forEach(product => {
			if (product.states.hover){
				this.states.hover = true;
			}

			if (product.states.open){
				this.states.open = true;
			}

			if (product.states.focus){
				this.states.focus = true;
			}

			// Differ from product states: Merge filtered and available to a single available var
			if (!product.states.filtered && product.states.available){
				this.states.available = true;
			}
				
			// if (!product.states.booked){
			// 	this.states.booked = false;
			// }
			
			// if (product.states.available){
			// 	this.states.available = true;
			// }
		});

		// Update view
		if (this.wheelItem){
			for (const key in this.states){
				this.wheelItem.classList.toggle('is-' + key, this.states[key]);
			}
		}

		if (this.sliderItem){
			for (const key in this.states){
				this.sliderItem.classList.toggle('is-' + key, this.states[key]);
			}
		}

		if (this.plan2D){
			for (const key in this.states){
				this.plan2D.classList.toggle('is-' + key, this.states[key]);
			}
		}

		// Update nav
		// this.floorService.nav.update()?
		//...
	}
}

class PlanNavigation{
	constructor(spot){
		this.focusItem = null;
		// this.plan = new SpotPlanEngine(spot.node, spot.display.settings);
		this.nav = spot.node.querySelector('.cmz-spot-plan-nav');
		this.status = 'close';
		
		// @todo - Create data-status from this.status 
		// The implementation of this.status and data-status is dirty. 
		// this.status was added to make sure that this.focusActiveItem() fire each time touchmove is triggered
		// Right now, data-status does not always correspond to this.status because they are created at different moment/events
		
		const touch = {
			start: {
				x: null,
				y: null,
			},
			diff: {
				x: 0,
				y: 0,
			},
			shift: 0,
			current: 0,
		};

		// Minicards
		this.nav.addEventListener('touchstart', (e) => {
			touch.start.y = e.touches[0].clientY;
			touch.start.x = e.touches[0].clientX;
			touch.diff.y = 0;

			// this.touch.timestart = Date.now();
			// this.touch.scroll = this.slider.scrollTop;
		});

		this.nav.addEventListener('touchmove', (e) => {
			// Bail early if touch didn't start on the element
			if (touch.start.y === null) return;

			// Get diff
			touch.diff.x = touch.start.x - e.touches[0].clientX;
			touch.diff.y = touch.start.y - e.touches[0].clientY;

			// Bail early if horizontal scroll intended
			if (Math.abs(touch.diff.x) > Math.abs(touch.diff.y)){
				return;
			}

			// Get diff (clamped between [0;88])
			// touch.diff.y = Math.max(0, Math.min(88, touch.start.y - e.touches[0].clientY));
			touch.shift = Math.max(0, Math.min(88, touch.current + touch.diff.y));

			const moveUp = touch.diff.y >= 0;

			// if (touch.diff.y > 50){
			if (moveUp && touch.shift >= 50){
				// Open completely
				touch.shift = 88;

				if (this.status != 'open'){
					this.status = 'open';
					this.focusActiveItem();
				}

			}
			else if (!moveUp && touch.shift < 50){
				// Close completely
				touch.shift = 0;
				// this.unfocus();

				if (this.status != 'close'){
					this.status = 'close';
					this.unfocus();
				}
			}
			else{
				// Slide freely
				this.nav.style.setProperty('--translate', touch.shift + 'px');
				spot.node.style.setProperty('--plan-nav-translate', touch.shift + 'px');
				this.nav.setAttribute('data-status', 'drag');
				this.status = 'drag';
			}

		});
		
		this.nav.addEventListener('touchend', (e) => {
			// Reset touch start
			touch.start.y = null;
			
			// Save current position
			touch.current = touch.shift;
			// touch.current = touch.current + touch.diff.y;
				
			// Define final state if slide let in the limbo
			if (this.nav.getAttribute('data-status') == 'drag'){
				this.nav.setAttribute('data-status', touch.shift >= 50 ? 'open' : 'close');
				// this.nav.setAttribute('data-status', 'close');
			}
			// touch.timeDown = null;

			// Move to item if significant drag detected
			if (touch.diff.y > 5){
				// this.scrollToItem(this.current.item); // @todo only fire this if dragged, not on click
			}
		});
		
		this.minicads = {
			slider: spot.node.querySelector('.cmz-spot-plan-products-minicards'),
			activeItemId : null, // item in center of slider
			items: spot.products.filter(product => {
				return product.available; // Remove unavailable products
			}).map(product => {
				return {
					id: product.id,
					node: product.nodes.minicard,
					// node: spot.node.querySelector('label[for="cmz-spot-plan-product-input-' + product.id + '"]')
				}	
			})
		};

		this._scrollMinicardSliderTo = () => {this.scrollMinicardSliderTo();}

		// Set first item activeItemId by default
		if (this.minicads.items.length){
			this.minicads.activeItemId = this.minicads.items[0].id;
		}

		const center = window.innerWidth / 2;
		let debounce;

		// Focus product on slider move
		this.minicads.slider.addEventListener('scroll', () => {
			for (let i = 0; i < this.minicads.items.length; i++) {
				const item = this.minicads.items[i];
				const {left, right} = item.node.getBoundingClientRect();

				if (left <= center && right >= center){
					if (this.minicads.activeItemId != item.id){
						this.minicads.activeItemId = item.id;

						clearTimeout(debounce);

						// Focus on product
						debounce = setTimeout(() => {
							// Remove autoscroll before firing focusActiveItem() to prevent item to be focused twice
							document.removeEventListener('cmzPlanProductFocused', this._scrollMinicardSliderTo);
								
							// Focus
							this.focusActiveItem();
							
							// Add autoscroll back
							document.addEventListener('cmzPlanProductFocused', this._scrollMinicardSliderTo);
							// this.plan.focusProduct(this.plan.getProduct(item.id), false);

							// Focus camera
							// this.plan.moveCameraTo(item.id);
							
							// Highlight product
							// this.plan.setInteraction('focus', this.plan.getProduct(item.id)); // Cradoc =/
						}, 400);
					}

					break;
				}
			}
		});

		if (window.innerWidth < 1024){
			document.addEventListener('cmzSpotPlan3DLoaded', () => {
				this.focusActiveItem();
			});
		}
	}

	// initialize(){
		// this.plan.initialize();
	// }

	scrollMinicardSliderTo(minicard){
		if (!minicard) return;

		this.minicads.slider.scrollTo({
			top: 0,
			left: minicard.offsetLeft,
			behavior: 'smooth'
		});
	}

	focusActiveItem(){
		this.nav.setAttribute('data-status', 'open');

		// Focus activeItemId item
		if (this.minicads.activeItemId){
			// Hook for 3D and 2D plans
			document.dispatchEvent(new CustomEvent('cmzSpotPlanProductFocus', {detail: {productId: this.minicads.activeItemId}}))
			// this.plan.focusProduct(this.plan.getProduct(this.minicads.activeItemId), false);
		}
	}
	
	unfocus(){
		this.nav.setAttribute('data-status', 'close');

		// Hook for 3D and 2D plans
		document.dispatchEvent(new CustomEvent('cmzSpotPlanProductUnfocus'));
		// this.plan.unfocus();
	}
}